import * as React from "react";

const SvgComponent = ({ width = "15px", height = "16px", color = "#229D08", ...props }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 16"
    {...props}
  >
    <path
      d="m5 6.879.315-.127.653.98 1.116-1.233-2.19-2.48L1.545.182C1.398.008 1.061-.056.83.055.113.371-.18 1.018.113 1.587l2.422 4.644c.358.742 1.538 1.042 2.464.647ZM9.085 8.775l-1.2 1.848 2.484 3.76c.38.568 1.306.79 2.043.474l.127-.064c.737-.316.969-1.042.484-1.563L9.085 8.775Z"
      fill={color}
    />
    <path
      d="M14.855 1.35c-.21-.142-.526-.095-.674.079 0 0-1.895 2.353-2.443 3.017-.084.095-.253.126-.379.079-.126-.063-.19-.19-.105-.285l2.253-3.095c.127-.174.021-.395-.252-.474-.19-.048-.4.016-.506.142L10.306 3.83c-.084.095-.253.126-.379.079-.126-.063-.19-.19-.105-.284L12.075.529c.127-.174.021-.395-.252-.474-.19-.048-.4.016-.506.142l-2.59 3.19-.316.427c-.337.427-.443.932-.295 1.327l.316.853-6.508 7.218c-.463.537-.253 1.248.484 1.564l.127.063c.737.316 1.685.11 2.043-.474l5.075-7.834 1.137-.221a2.409 2.409 0 0 0 1.39-.853l.316-.427 2.38-3.27c.169-.142.148-.315-.02-.41Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
